<template>
  <div class="container">
    <div class="card myTopMargin">
      <div class="card-body row g-3">
        <div class="form-group row-g5">
          <div class="input-group">
            <span class="input-group-text bg-secondary" id="inputGrouID" style="color: white">Kalkulace číslo</span>
            <input v-if="calculation" type="text" class="form-control" id="cnum" name="cnum"
                   :value="calculation.number"
                   readonly="">
          </div>

        </div>
      </div>
    </div>
    <!--    <CalculationBasicInfo v-if="calculation"-->
    <!--                          :calculation-info="calculation.detail"-->
    <!--                          :calculation-name="calculation.name"-->
    <!--                          :customer-id="calculation.detail.id"-->
    <!--                          v-model:calculation-name="calculation.name"-->
    <!--                          v-model:calculation-info="calculation.detail"-->
    <!--                          v-model:proforma="calculation.proformaValue"-->
    <!--                          v-model:delivery-time="calculation.deliveryTime"-->
    <!--                          v-model:delegated-vat="calculation.delegatedVat"-->
    <!--                          v-model:vat="calculation.vat"-->
    <!--                          v-model:internal-note="calculation.internalNote"/>-->

    <CalculationDetailSection
        v-if="calculation"
        :details="{
          name: calculation.name,
          proformaValue: calculation.proformaValue,
          deliveryTime: calculation.deliveryTime,
          vat: calculation.vat,
          delegatedVat: calculation.delegatedVat,
          internalNote: calculation.internalNote
        }"
        @update:details="Object.assign(calculation, $event)"
    />

    <CalculationCustomerSection
        v-if="calculation"
        v-model:customer="calculation.customer"
        v-model:deliveryAddress="calculation.deliveryAddress"
    />


    <CalculationItemsSection v-if="calculation"
                      :cid="cid"
                      :list-calculation-items="calculation.items"
                      @item-update="loadCalculation"/>
    <CalculationIndividualItemsSection v-if="calculation" :cid="cid"/>
    <CalculationMeasurementSection v-if="calculation"
                            :cid="calculation.uid"
                            :measure="calculation.measure"
                            v-model:measure="calculation.measure"/>
    <CalculationTransportSection v-if="calculation"
                          :cid="calculation.uid"
                          :calculation-items="calculation.items"
                          :transportation="calculation.transportation"
                          v-model:transportation="calculation.transportation"/>
    <CalculationAssemblySection v-if="calculation"
                         :cid="calculation.uid"
                         :calculation-items="calculation.items"
                         :assembly="calculation.assembly"
                         v-model:assembly="calculation.assembly"/>
    <CalculationPricturePickerSection v-if="calculation"
                               :cid="calculation.uid"/>
    <div class="row justify-content-end myTopMargin">
      <div class="col-auto">
        <button type="submit" class="btn btn-danger mx-1" @click="cancelButton">Zrušit</button>
        <button type="submit" class="btn btn-success mx-1" @click="saveButton">Uložit</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import CalculationItemsSection from "@/components/calculation/CalculationItemsSection.vue";
import CalculationTransportSection from "@/components/calculation/CalculationTransportSection.vue";
import CalculationAssemblySection from "@/components/calculation/CalculationAssemblySection.vue";
import CalculationIndividualItemsSection from "@/components/calculation/CalculationIndividualItemsSection.vue";
import CalculationMeasurementSection from "@/components/calculation/CalculationMeasurementSection.vue";
import CalculationPricturePickerSection from "@/components/calculation/CalculationPricturePickerSection.vue";
import router from "@/router";
import {ref, onMounted, defineProps} from 'vue';
import {useStore} from 'vuex';
import myApi from "@/api/api";
import CalculationCustomerSection from "@/components/calculation/CalculationCustomerSection.vue";
import CalculationDetailSection from "@/components/calculation/CalculationDetailSection.vue";

const props = defineProps(['cid']);
const store = useStore();
const calculation = ref(null);

const cancelButton = () => {
  router.push({name: 'home'})
};

const saveButton = () => {
  store.dispatch({type: 'calculation/updateCalculation', payload: calculation.value, showNotification: true})
      .then(() => {
        router.push({name: 'home'})
      })
};

const loadCalculation = async () => {
  try {
    // Počkáme na načtení kalkulace ze store
    await store.dispatch('calculation/setCalculationById', props.cid);
    calculation.value = store.getters['calculation/getCalculation'];

    // Kontrola statusu kalkulace
    if (calculation.value.status === 'order_confirmed') {
      alert("Kalkulaci nelze editovat, má-li potvrzenou objednávku!");
      router.push({name: 'home'});
      return;
    }

    // Pouze pokud kalkulace NEMÁ status 'order_confirmed', změníme status na 'in_progress'
    await myApi.setCalculationStatus(props.cid, 'in_progress');

  } catch (error) {
    console.error("Chyba při načítání kalkulace:", error);
    alert("Došlo k chybě při načítání kalkulace");
    router.push({name: 'home'});
  }
};

onMounted(async () => {
  await loadCalculation();
  console.log(calculation.value);
});
</script>

<style scoped>
</style>